import axios from "axios";
import React, { useState } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "./css/main.login.css";
import Register from "../register/Register";

const Login: React.FC = () => {
  const Cookies = require("js-cookie");
  const navagate = useNavigate();

  const [isShowLoginForm, setIsShowLoginForm] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [isRegister, setIsRegister] = useState(false);

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async () => {
    const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

    if (userName.trim() === "" || password.trim() === "") {
      Swal.fire({
        icon: "error",
        title: "Lỗi đăng nhập",
        text: "Vui lòng điền đầy đủ thông tin",
        customClass: {
          popup: "custom-swal",
          title: "custom-title",
          htmlContainer: "custom-text",
        },
      });
      return;
    } else if (userName.trim() != "" || password.trim() != "") {
      try {
        Swal.fire({
          title: "Đang xử lý...",
          text: "Vui lòng đợi giây lát",
          customClass: {
            popup: "custom-swal",
            title: "custom-title",
            htmlContainer: "custom-text",
          },
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
          },
        });

        // Chờ 3 giây
        await new Promise((resolve) => setTimeout(resolve, 1000));
        await axios
          .post(`${process.env.REACT_APP_URL_API}/auth/login`, {
            username: userName,
            password,
          })
          .then(async (data) => {
            localStorage.setItem(
              "user_info",
              JSON.stringify({
                userName: data.data.user.username,
                coins: data.data.user.coins,
                role: data.data.user.role,
                id: data.data.user._id,
              })
            );

            Cookies.set("access_token", data.data.access_token, {
              expires: 1 / 24,
              secure: false, // Thử false cho iOS
              sameSite: "Lax", // Thử Lax thay vì Strict
            });

            await new Promise((resolve) => setTimeout(resolve, 100));

            if (data.status === 201 && (data.data.user.role === "SUPERADMIN" || data.data.user.role === "ADMIN")) {
              Swal.fire({
                icon: "success",
                title: "Đăng nhập thành công",
                customClass: {
                  popup: "custom-swal",
                  title: "custom-title",
                  htmlContainer: "custom-text",
                },
              });
              setTimeout(() => {
                window.location.href = "/admin";
              }, 500);
            } else {
              Swal.fire({
                icon: "success",
                title: "Đăng nhập thành công",
                text: "Vui lòng đợi ít phút. ",
                customClass: {
                  popup: "custom-swal",
                  title: "custom-title",
                  htmlContainer: "custom-text",
                },
              });
              setTimeout(() => {
                window.location.href = "/";
              }, 500);
            }
          })
          .catch((err) => {
            if (err.status === 401) {
              Swal.fire({
                icon: "error",
                title: "Lỗi đăng nhập",
                text: "Tài khoản/mật khẩu không chính xác!",
                customClass: {
                  popup: "custom-swal",
                  title: "custom-title",
                  htmlContainer: "custom-text",
                },
              });
            }
          });
      } catch (error) {
        return error;
      }
    }
  };

  return (
    <div className="login-page ">
      {/* Background Video - Desktop */}
      <video 
        className="bgLogin bgLogin-desktop"
        autoPlay 
        loop 
        muted 
        playsInline
      >
        <source src="/assets/bg-login.mp4" type="video/mp4" />
      </video>
      
      {/* Background Image - Mobile */}
      <div 
        className="bgLogin bgLogin-mobile"
        style={{
          backgroundImage: 'url("/assets/bg-login-mb.png")',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          width: '100vw',
          height: '100vh',
        }}
      />
      
      {/* Header Titles - Mobile Only */}
      <div className="header-titles-mobile">
        <img src="/assets/header-title-1.png" alt="Header Title 1" className="header-title-img" />
        <img src="/assets/header-title-2.png" alt="Header Title 2" className="header-title-img" />
        <img src="/assets/header-title-3.png" alt="Header Title 3" className="header-title-img" />
      </div>
      
      {/* Header Bottoms - Mobile Only */}
      <div className="header-bottoms-mobile">
        <img src="/assets/header-bottom-1.png" alt="Header Bottom 1" className="header-bottom-img" />
        <img src="/assets/header-bottom-2.png" alt="Header Bottom 2" className="header-bottom-img" />
      </div>

      {/* Robot Title - Desktop */}
      <img 
        src="/assets/robot-title.png" 
        alt="Robot Title" 
        className="robot-title robot-title-desktop"
      />
      
      {/* Robot Title - Mobile */}
      <img 
        src="/assets/robot-hong.png" 
        alt="Robot Hong" 
        className="robot-title robot-title-mobile"
      />


      {/* Facebook Icon */}
      <a 
        href="#" 
        className="facebook-link"
      >
        <img 
          src="/assets/fb.png" 
          alt="Facebook"
          className="facebook-icon"
        />
      </a>

      {/* Telegram Icon */}
      <a 
        href="https://t.me/TONTON2026VIP" 
        target="_blank" 
        rel="noopener noreferrer"
        className="telegram-link"
      >
        <img 
          src="/assets/tele.png" 
          alt="Telegram"
          className="telegram-icon"
        />
      </a>

      <div
        className={`model-group ${
          isShowLoginForm || isRegister || isLogin ? "active" : ""
        }`}
      >
        <div className="overlay"></div>

        {/* Login Modal */}
        <div
          className={`model-item model-login ${
            isShowLoginForm || isLogin ? "model-login_active" : ""
          }  `}
        >
          <div
            className="btn-closeModel"
            onClick={() => {
              setIsShowLoginForm(false);
              setIsLogin(false);
            }}
          ></div>
          <p className="miniTxt">Đăng nhập</p>

          <div className="wrapper">
            <div className="title mb-2"></div>
            <form id="loginform" onSubmit={handleLogin}>
              <input
                className="bg-input mb-3"
                type="text"
                id="txtUsername"
                placeholder="Tên đăng nhập"
                onChange={(e) => setUserName(e.target.value)}
                maxLength={16}
                minLength={4}
                autoComplete="off"
                required
              />
              <input
                className="bg-input mb-3"
                type="password"
                id="txtPassword"
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Mật khẩu"
                maxLength={16}
                minLength={4}
                autoComplete="off"
                required
              />
              <div className="group-btn mt-4">
                <button type="button" className="btn-cancel"></button>
                <button
                  type="button"
                  className="btn-confirm"
                  onClick={handleLogin}
                ></button>
              </div>
            </form>
            <p className="txt-swith">
              Chưa có tài khoản?{" "}
              <span
                className="link-register"
                onClick={() => {
                  setIsShowLoginForm(false);
                  setIsRegister(true);
                }}
              >
                Đăng ký ngay
              </span>
            </p>
          </div>
        </div>

        {/* Register Modal */}
        <Register
          isRegister={isRegister}
          setIsShowLogin={() => setIsLogin(true)}
          setIsRegister={() => setIsRegister(false)}
        />
      </div>

      <div className="index-page_wrapper">
        <div id="bg-canvas">
          <canvas
            className="particles-js-canvas-el"
            width="1366"
            height="641"
          ></canvas>
        </div>
        <div className="logo">
          <img
            src="https://trumcasino6789.com/images/logo.png"
            alt="Logo"
            className="logo_main"
          />
          <div className="wrapper-content">
            <div className="group-btn">
              <div
                className="btn-item btn-login"
                onClick={() => {
                  setIsShowLoginForm(true);
                }}
              ></div>
              <div
                className="btn-item btn-register"
                onClick={() => {
                  setIsRegister(true);
                }}
              ></div>
            </div>
            <div className="group-btn-download">
              <div 
                className="btn-item btn-download"
                onClick={() => {
                  const fileId = '1QmEPQxZXIM8jAXVX1VxuFrZ6tH7lmexE';
                  const downloadUrl = `https://drive.google.com/uc?export=download&id=${fileId}&confirm=t`;
                  window.open(downloadUrl, '_blank');
                }}
                style={{ cursor: 'pointer' }}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    const fileId = '1QmEPQxZXIM8jAXVX1VxuFrZ6tH7lmexE';
                    const downloadUrl = `https://drive.google.com/uc?export=download&id=${fileId}&confirm=t`;
                    window.open(downloadUrl, '_blank');
                  }
                }}
                aria-label="Download APK"
              ></div>
            </div>
            <div className="casino-logos">
              <img src="/assets/idol.png" alt="IDOL" />
              <img src="/assets/sa.png" alt="SA" />
              <img src="/assets/sexy.png" alt="SEXY" />
              <img src="/assets/wm.png" alt="WM" />
              <img src="/assets/dg.png" alt="DG" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
